import { call, put, takeLatest } from 'redux-saga/effects'

import { postModule, putModule, deleteModule } from '@galo-monitor/services/apis/galoMonitorApi/resources/module'

import { ModuleActions, ModuleTypes } from './duckModule'

function* saveModule({ mod, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(mod.id ? putModule : postModule , mod)
    yield call(onSuccess)
  } catch (err) {
    yield put(ModuleActions.moduleError(err.message))
    yield call(onError, err)
  }
}

function* removeModule({ mod, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteModule, mod)
    yield call(onSuccess)
  } catch (err) {
    yield put(ModuleActions.moduleError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(ModuleTypes.SAVE_MODULE, saveModule),
  takeLatest(ModuleTypes.REMOVE_MODULE, removeModule)
]
